import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.reference),expression:"reference"}],staticClass:"ml-1 v-btn--active",staticStyle:{"text-transform":"none"},attrs:{"color":"primary lighten-2","text":""}},'v-btn',_vm.$attrs,false),[_c('span',{staticClass:"primary--text"},[_vm._v(" "+_vm._s(_vm.reference)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }